import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'highlight'
})
export class HighlightPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string, textColor: string = '', bgColor: string = ''): SafeHtml {
    if (!value) {
      return value;
    }

    // Highlight only uppercase HRIS, HRMS, DMS, ATS, PAY, HCM
    const highlightWords = ['HRIS', 'HRMS', 'DMS', 'ATS', 'PAY', 'HCM'];
    const regex = new RegExp(`\\b(${highlightWords.join('|')})\\b`, 'g');

    let highlightedText = value.toString().replace(regex, match => {
      return `<span style="
        background-color:${bgColor};
        color:${textColor};
        font-family:'Roboto Slab','Rockwell',serif;
        font-weight:bold;
        padding:0px 6px;
        border-radius:4px;
        font-size:0.6em; 
      ">${match}</span>`;
    });

    // Highlight vmanico only with color (case-insensitive)
    const vmanicoRegex = /(vmanico)/gi;
    highlightedText = highlightedText.replace(
      vmanicoRegex,
      `<span style="
        color:${textColor};
        font-weight:bold;
      ">$1</span>`
    );

    // Highlight PaaS with clip-path background
const paasRegex = /(PaaS)/g;
highlightedText = highlightedText.replace(
  paasRegex,
  ``
);

    return this.sanitizer.bypassSecurityTrustHtml(highlightedText);
  }
}





